
import React, { useEffect, useState } from 'react'
import { MdAddCircleOutline, MdClose } from 'react-icons/md';
import { IConstantAuctionParameters, IPriceModelContent, IReverseDutchAuctionPriceModelParameters, PriceModelTypes, ReverseDutchAuctionPriceModelParametersPricePoint } from '../../planEatApi/PlanEatFacade';
import { Modal } from '../ui/Modal';
import { Button, FormControl, IconButton, InputLabel, MenuItem, OutlinedInput, Select} from '@material-ui/core';
import { InputField } from '../ui/InputField';
import { makeStyles } from '@material-ui/core';
import { CancelCrudButtons } from '../ui/CancelCrudButtons';
import { AddItemButton } from '../ui/AddItemButton';

const useStyles = makeStyles((theme: any) => ({
    container:{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        rowGap: 30
    },
    twoItemRow: {
        display: 'grid',
        gridTemplateColumns: "repeat(2, minmax(0, 1fr));",
        width: '100%',
        gap: 15,
        paddingTop: 20,
    },
    title: {
        fontWeight: 'bold',
        fontSize: 18
    },
    threeItemRow: {
        display: 'grid',
        justifyContent: 'flex-start',
        gridTemplateColumns: '30% 30% 56px',
        width: '100%',
        gap: 15,
        paddingTop: 20,
    }
}));

interface Props {
    priceModelCreationModalHidden: boolean;
    priceModel: IPriceModelContent;
    setPriceModel: React.Dispatch<React.SetStateAction<IPriceModelContent>>;
    setPriceModelCreationModalHidden: React.Dispatch<React.SetStateAction<boolean>>;
    postPriceModel: (priceModel: IPriceModelContent) => void
}


export const PriceModelCreationModal: React.FC<Props> = ({priceModelCreationModalHidden,setPriceModelCreationModalHidden,postPriceModel,priceModel,setPriceModel}) => {
    // Styling
    const classes = useStyles()

    const [auctionTypes, setAuctionTypes] = useState<PriceModelTypes[]>([PriceModelTypes.REVERSE_DUTCH_AUCTION,PriceModelTypes.CONSTANT_AUCTION])
    const [selectedAuctionType, setSelectedAuctionType] = useState<PriceModelTypes>(PriceModelTypes.REVERSE_DUTCH_AUCTION)

    // Price models
    const [reverseDutchAuction, setReverseDutchAuction] = useState<IReverseDutchAuctionPriceModelParameters>({
        cutOffTimeADay: "",
        cutOffDaysBefore: 0,
        pricePoints:[{cutOffHour:0,price:0}]
    })

    const [constantAuction, setConstantAuction] = useState<IConstantAuctionParameters>({
        cutOffTimeADay: "",
        cutOffDaysBefore: 0,
        price: 0
    })

    // Price models view
    const [reverseDutchAuctionView, setReverseDutchAuctionView] = useState<any[]>([]);
    const [constantAuctionView, setConstantAuctionView] = useState<any[]>([]);

    function initModel(reset: boolean){
        if(priceModel.priceModelType=== PriceModelTypes.REVERSE_DUTCH_AUCTION){
            setSelectedAuctionType(PriceModelTypes.REVERSE_DUTCH_AUCTION)
            if(priceModel.id !== "" && !reset){
                const tmpReverseDutchAuction: IReverseDutchAuctionPriceModelParameters = JSON.parse(priceModel.priceModelParameters)
                setReverseDutchAuction(tmpReverseDutchAuction)
            } else{
                setReverseDutchAuction({
                    cutOffTimeADay: "",
                    cutOffDaysBefore: 0,
                    pricePoints:[{cutOffHour:0,price:0}]
                })
            }
        } else if (priceModel.priceModelType=== PriceModelTypes.CONSTANT_AUCTION){
            setSelectedAuctionType(PriceModelTypes.CONSTANT_AUCTION)
            if(priceModel.id !== "" && !reset){
                const tmpConstantAuction: IConstantAuctionParameters = JSON.parse(priceModel.priceModelParameters)
                setConstantAuction(tmpConstantAuction)
            } else{
                setConstantAuction({
                    cutOffTimeADay: "",
                    cutOffDaysBefore: 0,
                    price:0
                })
            }
        }
    }

    useEffect(() => {
       if(!priceModelCreationModalHidden){
            if(priceModel.id !== ""){
                initModel(false)
            } else {
                initModel(true)
            }
       }
    },[priceModelCreationModalHidden])
    

    useEffect(() => {
        if(selectedAuctionType=== PriceModelTypes.REVERSE_DUTCH_AUCTION){
            displayReverseDutchAuctionView()
        }
    },[reverseDutchAuction])

    function handleReverseDutchAuctionChange(e: any,index: number, type: string){
        if(reverseDutchAuction?.pricePoints){
            var tmpPricePoints : ReverseDutchAuctionPriceModelParametersPricePoint[] = [];

            reverseDutchAuction?.pricePoints.forEach((pricePoint, j) => {
                if(index === j){
                    if(type === "CUTOFF"){
                        pricePoint.cutOffHour = parseInt(e.target.value);
                    } else if (type === "PRICE"){
                        pricePoint.price = parseInt(e.target.value);
                    }
                }
                tmpPricePoints.push(pricePoint)
            })
    
            setReverseDutchAuction({
                cutOffTimeADay: reverseDutchAuction.cutOffTimeADay,
                cutOffDaysBefore: reverseDutchAuction.cutOffDaysBefore,
                pricePoints:tmpPricePoints
            })
        }
    }   

    function reverseDutchAuctionRemoveItem(index: number){
        if(reverseDutchAuction?.pricePoints){
            var tmpReverseDutchAuctionPricePoints: ReverseDutchAuctionPriceModelParametersPricePoint[] = []
            reverseDutchAuction.pricePoints.forEach((pricePoint,j) => {
                if(index !== j){
                    tmpReverseDutchAuctionPricePoints.push(pricePoint)
                }
            })
    
            setReverseDutchAuction({
                cutOffTimeADay: reverseDutchAuction.cutOffTimeADay,
                cutOffDaysBefore: reverseDutchAuction.cutOffDaysBefore,
                pricePoints: tmpReverseDutchAuctionPricePoints
            })
        }
    }

    function reverseDutchAuctionAddItem(){
        var tmpReverseDutchAuctionPricePoints: ReverseDutchAuctionPriceModelParametersPricePoint[] = []
        reverseDutchAuction.pricePoints.forEach((pricePoint) => {
            tmpReverseDutchAuctionPricePoints.push(pricePoint)
        })
        tmpReverseDutchAuctionPricePoints.push({cutOffHour:0,price:0})

        setReverseDutchAuction({
            cutOffTimeADay: reverseDutchAuction.cutOffTimeADay,
            cutOffDaysBefore: reverseDutchAuction.cutOffDaysBefore,
            pricePoints: tmpReverseDutchAuctionPricePoints
        })
    }

    function displayReverseDutchAuctionView(){
        if(reverseDutchAuction){
            var tmpReverseDutchAuctionView: any[] = []
            
            reverseDutchAuction.pricePoints.forEach((pricePoint, index) => {
                tmpReverseDutchAuctionView.push(
                    <div className={classes.threeItemRow}>
                        <InputField 
                            variant='outlined'
                            label='Cutoff before (hours)'
                            type="number" 
                            placeholder="Enter a cutoff time in hours..."
                            value={pricePoint.cutOffHour}
                            onChange={(e) => {handleReverseDutchAuctionChange(e,index,"CUTOFF")}}
                            fullWidth
                        />
                        <InputField 
                            variant='outlined'
                            label='Price'
                            type="number" 
                            placeholder="Enter a price at that given cutoff..."
                            value={pricePoint.price}
                            onChange={(e) => {handleReverseDutchAuctionChange(e,index,"PRICE")}}
                            fullWidth
                        />
                        <IconButton onClick={() => {reverseDutchAuctionRemoveItem(index)}}>
                            <MdClose color="red"/>
                        </IconButton>
                    </div>
                )
            })
            
            // Add new price points
            tmpReverseDutchAuctionView.push(
                <AddItemButton onClick={() => {reverseDutchAuctionAddItem()}} title="Add Price Points" />
            )
            setReverseDutchAuctionView(tmpReverseDutchAuctionView)
        } else {
            initModel(true)
        }
    }

    function postReverseDutchAuction(){
        reverseDutchAuction.cutOffDaysBefore = parseInt(reverseDutchAuction.cutOffDaysBefore.toString())
        priceModel.priceModelParameters = JSON.stringify(reverseDutchAuction);
        priceModel.priceModelType = PriceModelTypes[selectedAuctionType]
        postPriceModel(priceModel)
    }

    function postConstantPriceModel(){
        constantAuction.cutOffDaysBefore = parseInt(constantAuction.cutOffDaysBefore.toString())
        constantAuction.price = parseInt(constantAuction.price.toString())
        priceModel.priceModelParameters = JSON.stringify(constantAuction);
        priceModel.priceModelType = PriceModelTypes[selectedAuctionType]
        postPriceModel(priceModel)
    }

    const handlePriceModelChange = (prop: keyof IPriceModelContent) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setPriceModel({ ...priceModel, [prop]: event.target.value });
    };

    const handleReverseDutchAuctionPriceModelParametersChange = (prop: keyof IReverseDutchAuctionPriceModelParameters) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setReverseDutchAuction({ ...reverseDutchAuction, [prop]: event.target.value });
    };

    const handleConstantAuctionChange = (prop: keyof IConstantAuctionParameters) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setConstantAuction({ ...constantAuction, [prop]: event.target.value });
    };

    const handlePriceModelTypeChange = (value: any) => {
        if(value=== PriceModelTypes.REVERSE_DUTCH_AUCTION){
            setSelectedAuctionType(PriceModelTypes.REVERSE_DUTCH_AUCTION)
        } else if (value=== PriceModelTypes.CONSTANT_AUCTION){
            setSelectedAuctionType(PriceModelTypes.CONSTANT_AUCTION)
        }
    };

    return (
        <Modal title='Create price model' hidden={priceModelCreationModalHidden} setHidden={setPriceModelCreationModalHidden}>
            <div className={classes.container}>
                <div className={classes.title}>Auction Type</div>
                <FormControl variant="outlined">
                    <InputLabel shrink>Choose auction type</InputLabel>
                    <Select
                        input={<OutlinedInput notched label="Choose auction type" />}
                        label='Choose auction type'
                        value={selectedAuctionType}
                        onChange={e => {handlePriceModelTypeChange(e.target.value)}}
                        fullWidth
                    >
                        {auctionTypes.map((auctionType,key) => <MenuItem value={auctionType} key={key}>{PriceModelTypes[auctionType]}</MenuItem>)}
                    </Select>
                </FormControl>
                <div>
                    <div className={classes.title}>General information</div>
                    <div className={classes.twoItemRow}>
                        <InputField 
                            variant='outlined'
                            label='Name'
                            type="text" 
                            placeholder="Enter a name for the price model..."
                            value={priceModel.name}
                            onChange={handlePriceModelChange("name")}
                            fullWidth
                        />
                        <InputField 
                            variant='outlined'   
                            label='Description'
                            type="text" 
                            placeholder="Enter a description for the price model..."
                            onChange={handlePriceModelChange("description")}
                            value={priceModel.description}
                            fullWidth
                        />
                    </div>
                </div>
                <div>
                    {
                        selectedAuctionType=== PriceModelTypes.REVERSE_DUTCH_AUCTION && reverseDutchAuction?
                        <div>
                            <div className={classes.twoItemRow}>
                                <InputField 
                                    variant='outlined'
                                    label='Cut off time a day'
                                    type="time" 
                                    placeholder="Enter a time of day to cut off..."
                                    value={reverseDutchAuction.cutOffTimeADay}
                                    onChange={handleReverseDutchAuctionPriceModelParametersChange("cutOffTimeADay")}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    fullWidth
                                />
                                <InputField 
                                    variant='outlined'
                                    label='Cut off day(s) before'
                                    type="number" 
                                    placeholder="Enter a description for the price model..."
                                    value={reverseDutchAuction.cutOffDaysBefore}
                                    onChange={handleReverseDutchAuctionPriceModelParametersChange("cutOffDaysBefore")}
                                    helperText="If cut off is on the same day enter 0"
                                    fullWidth
                                />
                            </div>
                            <div>
                                <div className={classes.title}>Price intervals</div>
                                <div>
                                    {reverseDutchAuctionView}
                                </div>
                            </div>
                            <CancelCrudButtons 
                                hidden={priceModelCreationModalHidden}
                                setHidden={setPriceModelCreationModalHidden}
                                isDelete={false}
                                postButtonText={priceModel.id ? "Update" : "Create" + "Price Model"}
                                postEntity={postReverseDutchAuction}
                            />
                        </div>
                        :
                        selectedAuctionType=== PriceModelTypes.CONSTANT_AUCTION ?
                        <div>
                            <div>
                                <div className={classes.twoItemRow}>
                                    <InputField 
                                         variant='outlined'
                                        label='Cut off time a day'
                                        type="time" 
                                        placeholder="Enter a time of day to cut off..."
                                        value={constantAuction.cutOffTimeADay}
                                        onChange={handleConstantAuctionChange("cutOffTimeADay")}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        fullWidth
                                    />
                                    <InputField 
                                         variant='outlined'
                                        label='Cut off day(s) before'
                                        type="number" 
                                        placeholder="Enter a description for the price model..."
                                        value={constantAuction.cutOffDaysBefore}
                                        onChange={handleConstantAuctionChange("cutOffDaysBefore")}
                                        helperText="If cut off is on the same day enter 0"
                                        fullWidth
                                    />
                                </div>
                            </div>
                            <div>
                                <div className={classes.title}>Price</div>
                                <div className={classes.twoItemRow}>
                                    <InputField 
                                        variant='outlined'
                                        label="Price"
                                        type="number" 
                                        placeholder="Enter price..."
                                        helperText="If no price enter 0"
                                        value={constantAuction.price}
                                        onChange={handleConstantAuctionChange("price")}
                                        fullWidth
                                    />
                                </div>
                            </div>
                            <CancelCrudButtons 
                                hidden={priceModelCreationModalHidden}
                                setHidden={setPriceModelCreationModalHidden}
                                isDelete={false}
                                postButtonText={priceModel.id ? "Update" : "Create" + "Price Model"}
                                postEntity={postConstantPriceModel}
                            />
                        </div>
                        :
                        <div>
                            No matching price model
                        </div>
                    }
                </div>
            </div>
        </Modal>
    );
}